import { RHFAutocomplete } from '@aibees/shared/components';
import { capitalize } from '@aibees/shared/utils';
import { memo } from 'react';
import {
  USER_MEMBER_OPTIONS,
  USER_MEMBER_OPTIONS_WITHOUT_OWNER,
} from './config';
import type { UserRoleDropdownProps as Props } from './types';

export const UserRoleDropdown = memo(
  ({
    className: _className,
    placeholder,
    label = 'Role',
    name,
    withoutOwner,
    size,
    disabled,
    helperText: _helperText,
    FormHelperTextProps: _FormHelperTextProps,
    InputProps,
    InputLabelProps,
  }: Props) => {
    // const {
    //   control,
    //   formState: { errors },
    // } = useFormContext();
    // const error = errors[name];

    const options = withoutOwner
      ? USER_MEMBER_OPTIONS_WITHOUT_OWNER
      : USER_MEMBER_OPTIONS;

    // const helperTextMemoized = useCallback(
    //   (fieldError?: any) => {
    //     if (fieldError) return fieldError?.message;
    //     if (helperText) return helperText;
    //     return '\u00A0'; // Non-breaking space for consistent spacing
    //   },
    //   [helperText]
    // );

    return (
      <RHFAutocomplete
        name={name}
        size={size}
        disabled={disabled}
        fullWidth
        label={label}
        helperText={' '}
        placeholder={placeholder || label}
        disableClearable
        options={options}
        getOptionLabel={(option) => capitalize(option as string)}
        InputProps={InputProps}
        InputLabelProps={{
          ...InputLabelProps,
          shrink: InputLabelProps?.shrink ?? Boolean(placeholder),
        }}
      />
    );

    /* <Styled.Wrapper
      className={classnames('UserRoleDropdown', className)}
      name={name || 'user'}
      label={label}
      disabled={disabled}
      placeholder={label || 'Select Role'}
      options={
        withoutOwner ? USER_MEMBER_OPTIONS_WITHOUT_OWNER : USER_MEMBER_OPTIONS
      }
      getOptionLabel={(x) => capitalize(x as string)}
      PaperComponent={Styled.CustomPaper}
      helperText={' '}
      {...props}
    /> */

    /* return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DropDown
            className={classnames('UserRoleDropdown', className)}
            label={label}
            placeholder={placeholder || label}
            options={options}
            size={size}
            disabled={disabled}
            helperText={helperTextMemoized(error)}
            FormHelperTextProps={FormHelperTextProps}
            {...field}
            {...props}
          />
        )}
      />
    ); */
  }
);

UserRoleDropdown.displayName = 'UserRoleDropdown';
